import { ReactNode } from 'react';
import { createPortal } from 'react-dom';

export const Portal = ({ containerId = 'modals', children }: { containerId?: string; children: ReactNode }) => {
  const container = document.getElementById(containerId);

  if (!container) {
    return null;
  }

  return createPortal(children, container);
};
